import { Injectable, signal, inject, computed } from '@angular/core';
import { TableColumn } from '@ui/aos-lib';
import { combineLatest, of, take } from 'rxjs';

import {
  ListingDataSource,
  ListingFiltersSource,
  ListingPageModel
} from '../../../shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { ListingTableComponent } from '../../../shared/components/listing-table/listing-table.component';
import { OrderDirection } from '../../equipment/devices/components/devices.models';

import { SEARCH_TYPES, tableConfig, userRolesTableSortFiled } from './user-roles.constants';
import { UserRolesService } from './services/user-roles.service';
import { UserRolesTable } from './user-roles.types';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { PermissionValue, ResourceValue } from '../../../services/permissions/permissions.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { ListingPageModelAbstract } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model-abstract';
import { ListingPageId } from '@portal/shared/components/listing-page/store/listing-page-store.types';
import { ListingPageModelRegistry } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model-registry.service';

@Injectable({ providedIn: 'root' })
export class UserRolesListingModelService extends ListingPageModelAbstract implements ListingPageModel {
  private readonly userRolesService = inject(UserRolesService);
  private readonly permissions = inject(PermissionsService);
  readonly listingPageModelRegistry = inject(ListingPageModelRegistry);

  readonly exportButtonVisible = false;
  readonly columnsButtonVisible = false;
  readonly pageTitle = TranslateRegistry.get.USER_ROLES.TITLE.USER_ROLES;
  readonly searchTypeList = computed(() => SEARCH_TYPES);
  readonly selectedSearchType = computed(() => SEARCH_TYPES[0]);
  readonly sortField = userRolesTableSortFiled;
  readonly sorting = computed(() => ({
    columnName: userRolesTableSortFiled.roleName,
    orderDirection: OrderDirection.ASC
  }));
  tableColumns = signal<TableColumn[]>([]);
  readonly dataSource: ListingDataSource<UserRolesTable> = {
    getAll: tableState => this.userRolesService.getTableData(tableState),
    total: 0
  };
  readonly tableCmp = ListingTableComponent;
  readonly permissionGroup$ = combineLatest([
    this.permissions.hasRight(ResourceValue.PERMISSIONS_MGT, PermissionValue.EDIT),
    this.permissions.hasRight(ResourceValue.PERMISSIONS_MGT, PermissionValue.DELETE)
  ]);

  readonly pageId = ListingPageId.UserRoles;
  readonly filterSource: ListingFiltersSource = {
    getAll: () => of([]),
    getReportGroup: () => of()
  };
  constructor() {
    super();
    const listingPageModelRegistry = this.listingPageModelRegistry;

    listingPageModelRegistry.add(this.pageId, this);
    this.getActionsPermission();
  }

  //todo: refactor into a signal, e.g. tableColumns = computed(() => toSignal(this.permissionGroup$) ? tableConfig : tableConfig.filter())
  getActionsPermission(): void {
    this.permissionGroup$
      .pipe(take(1))
      .subscribe(([hasPermissionEditRight, hasPermissionDeleteRight]) =>
        this.tableColumns.set(
          hasPermissionEditRight || hasPermissionDeleteRight
            ? tableConfig
            : tableConfig.filter(col => col.field !== 'id')
        )
      );
  }
}
